import './health-claims.scss';

/*
 * Placeholder for the health claims pages that have no data source yet
 * (Direct billing and AZADEA reimbursement claims), so they lead somewhere
 * rather than to a dead link.
 */
export default function HealthClaims() {
  return (
    <div className="health-claims">
      <p className="health-claims__body">Coming soon</p>
    </div>
  );
}
